import { Stack, Divider } from "@chakra-ui/layout";
import { useContext } from "react";
import {
  Drawer,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
} from "@chakra-ui/modal";
import { useColorModeValue } from "@chakra-ui/react";
import SidebarContent from "./SidebarContent";
import { useNav } from "../../context/NavContext";

const MobileSidebar = () => {
  const { isNavOpen, closeNav } = useNav();
  const bg = useColorModeValue("primary.500", "primary.800"); // Adapts to theme mode

  return (
    <Drawer isOpen={isNavOpen} onClose={closeNav} placement="left">
      <DrawerOverlay display={{ base: "initial", md: "none" }}>
        <DrawerContent bgColor={bg} layerStyle="neutral" data-cy="drawer">
          <DrawerCloseButton mt="32px" color="white"/>
          <SidebarContent />
        </DrawerContent>
      </DrawerOverlay>
    </Drawer>
  );
};

export default MobileSidebar;
